import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { buildPublicVideoStreamUrl } from "../lib/adminVideo";

/** Repli SPA — le lien partagé recommandé est l’URL API publique signée (lecteur HTML serveur). */
export default function WatchVideo() {
  const { sessionId } = useParams();
  const [searchParams] = useSearchParams();
  const variant = searchParams.get("variant") || "composite";
  const sig = searchParams.get("sig") || "";

  const [missingSig, setMissingSig] = useState(false);

  useEffect(() => {
    setMissingSig(!sig);
  }, [sig]);

  const videoSrc = useMemo(() => {
    if (!sessionId || !sig) return null;
    return buildPublicVideoStreamUrl(sessionId, sig, variant);
  }, [sessionId, sig, variant]);

  if (!sessionId || missingSig) {
    return (
      <div className="min-h-screen bg-[#0a1628] text-white flex items-center justify-center p-6">
        <p className="text-white/70 text-center max-w-md">
          Lien incomplet. Copiez l&apos;URL depuis l&apos;admin avec « Copier l&apos;URL » (lien public signé).
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a1628] text-white flex flex-col">
      <header className="px-4 py-3 border-b border-white/10">
        <h1 className="text-lg font-semibold">Maillon Faible — enregistrement</h1>
      </header>
      <main className="flex-1 flex items-center justify-center p-4">
        <video
          key={videoSrc}
          src={videoSrc}
          controls
          playsInline
          className="w-full max-w-5xl max-h-[calc(100vh-5rem)] rounded-lg bg-black shadow-2xl"
        />
      </main>
    </div>
  );
}
